export const SAVE_FIELD = "login/SAVE_FIELD";
export const RESET_FIELD = "login/RESET_FIELD";

export const CHANGE_INFO_CHECK_CODE = "login/CHANGE_INFO_CHECK_CODE";
export const CHANGE_STEP = "login/CHANGE_STEP";

export const GET_DATA_TO_RETYPE_OTP = "login/GET_DATA_TO_RETYPE_OTP";

// SAU KHI TÁCH MEDPRO ID
export const REDIRECT_TO_MEDPRO_ID = "login/REDIRECT_TO_MEDPRO_ID";
export const SET_CURRENT_URL = "login/SET_CURRENT_URL";
